import logoLogin from 'assets/images/logo-login.png'

export const LogoLogin = () => (
  <div className="max-w-[200px] sm:max-w-[400px]">
    <img src={logoLogin} alt="" className="w-full" />
  </div>

)
